var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-detail-header", {
        attrs: {
          "show-toggle": true,
          "show-new": false,
          "show-print": false,
          "show-delete": false,
          "show-save": false,
        },
        on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
      }),
      _c("div", { staticClass: "columns is-gapless" }, [
        _c(
          "div",
          { staticClass: "column is-narrow" },
          [
            _vm.options
              ? _c("audit-trail-side-menu", {
                  model: {
                    value: _vm.options,
                    callback: function ($$v) {
                      _vm.options = $$v
                    },
                    expression: "options",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column" },
          [
            _vm.options && _vm.showEditor && _vm.entity
              ? _c("audit-trail-detail", {
                  attrs: { options: _vm.options },
                  model: {
                    value: _vm.entity.newValue,
                    callback: function ($$v) {
                      _vm.$set(_vm.entity, "newValue", $$v)
                    },
                    expression: "entity.newValue",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }